import { GenericFunctionService } from '@kunlun/dependencies';

/**
 * 授信等级系数配置行数据
 */
export interface CoefficientRow {
  id?: string;
  /** 授信等级 A/B/C/D */
  creditRating: string;
  /** 超账龄次数（默认0、1、2次以上，D级为空，不允许编辑） */
  overLimitTimes: number | null;
  /** 电商客户系数 */
  ecommerceCoefficient: number | null;
  /** 线下客户系数 */
  offlineCoefficient: number | null;
  /** 折扣 */
  discount: number | null;
}

/** 系数配置代理模型编码 */
export const COEFFICIENT_MODEL = 'deli.aries.platform.fund.banks.DeliAriesPlatformCreditReviewCoefficientProxy';

/**
 * 查询所有授信等级系数配置（后端会在为空时初始化 A/B/C/D 四条默认记录）
 */
export async function queryAllCoefficients(): Promise<CoefficientRow[]> {
  const res = await GenericFunctionService.INSTANCE.simpleExecuteByFun(COEFFICIENT_MODEL, 'queryAllCoefficients', {});
  return (res as CoefficientRow[]) || [];
}

/**
 * 保存授信等级系数配置
 * @param list 系数配置列表
 */
export async function saveCoefficientConfig(list: CoefficientRow[]): Promise<CoefficientRow[]> {
  const res = await GenericFunctionService.INSTANCE.simpleExecuteByFun(COEFFICIENT_MODEL, 'saveCoefficientConfig', list);
  return (res as CoefficientRow[]) || [];
}
